import React, { useState, useRef } from "react";
import CodeExecutor from "../../../../../components/CodeExecutor/CodeExecutor.js";
import {
  Card,
  Row,
  Col,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import { testVariableDeclaration } from "./TestVariableDeclarationAndInitialization.js";
import "./VariableDeclarationAndInitialization.css";
import classnames from "classnames";
import { useLesson } from "../../../../../hooks/lessonFramework";
import { useUserAuth } from "../../../../../context/UserContext";

const VariableDeclarationAndInitialization = () => {
  const { lessonCode, setInitialCode } = useLesson();
  const mainRef = useRef(null);
  const { user } = useUserAuth();
  const [activeTab, setActiveTab] = useState("1");

  const executeTests = (code) => {
    const newCheckedStates = testVariableDeclaration(code, checkedStates, user);
    updateCheckboxState(newCheckedStates);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // CHECKBOXS
  const [checkedStates, setCheckedStates] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: true,
  });

  // Function to update the state of specific checkboxes
  const updateCheckboxState = (updates) => {
    setCheckedStates((prevState) => ({
      ...prevState,
      ...updates, // Merge the updates into the current state
    }));
  };
  // CHECKBOXS

  return (
    <>
      <DemoNavbar />
      <main ref={mainRef}>
        <section className="section section-shaped section-lg bg-gradient-default">
          <Row className="justify-content-center ">
            <Col style={{ padding: 0 }}>
              <CodeExecutor
                languageCode="java"
                initialCode={lessonCode}
                runTestCase={executeTests}
              >
                <Card className="my-2 lessonCard scroll-container">
                  <CardHeader>Introduction to Primitive Data Types</CardHeader>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <CardBody>
                        <CardTitle tag="h5">
                          Variable Declaration and Initialization
                        </CardTitle>
                        <CardText>
                          Variables are containers for storing data values. A
                          variable in Java must be declared with a specific data
                          type before it can be used. This declaration informs
                          the compiler about the type of data the variable will
                          hold, ensuring that it is used correctly.
                        </CardText>
                        <CardTitle tag="h5">Variable Declaration: </CardTitle>
                        <CardText>
                          Involves specifying the data type followed by the
                          variable name. This step allocates memory for the
                          variable but does not assign it a value. Example:
                          <br />
                          <code>
                            int age; // Declares an integer variable named age
                          </code>
                        </CardText>

                        <CardTitle tag="h5">Variable Initialization:</CardTitle>
                        <CardText>
                          This involves assigning a value to the declared
                          variable. Initialization can occur at the time of
                          declaration or later in the code. Example:
                          <br />
                          <code>
                            age = 25; // Assigns the value 25 to the variable
                            age
                          </code>
                        </CardText>

                        <CardTitle tag="h5">
                          Combined Declaration and Initialization:{" "}
                        </CardTitle>
                        <CardText>
                          Variables can be declared and initialized in a single
                          statement, which is a common practice for clarity and
                          conciseness. Example:
                          <br />
                          <code>
                            int height = 175; // Declares and initializes an
                            integer variable named height
                          </code>
                        </CardText>

                        <CardTitle tag="h5">
                          THIS IS A TEST FROM THIS POINT FOWARD{" "}
                        </CardTitle>
                        <CardTitle tag="h5">
                          Combined Declaration and Initialization:{" "}
                        </CardTitle>
                        <CardText>
                          Variables can be declared and initialized in a single
                          statement, which is a common practice for clarity and
                          conciseness. Example:
                          <br />
                          <code>
                            int height = 175; // Declares and initializes an
                            integer variable named height
                          </code>
                        </CardText>
                      </CardBody>
                    </TabPane>

                    <TabPane tabId="2">
                      <CardBody>
                        {/* CHECKBOXS */}
                        <h4>Try It Yourself</h4>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox1"
                                checked={checkedStates.checkbox1}
                                readOnly
                              />
                              Problem 1
                            </Label>
                          </FormGroup>
                        </div>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox2"
                                checked={checkedStates.checkbox2}
                                readOnly
                              />
                              Problem 2
                            </Label>
                          </FormGroup>
                        </div>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox3"
                                checked={checkedStates.checkbox3}
                                readOnly
                              />
                              Problem 3
                            </Label>
                          </FormGroup>
                        </div>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox4"
                                checked={checkedStates.checkbox4}
                                readOnly
                              />
                              Problem 4
                            </Label>
                          </FormGroup>
                        </div>
                        {/* CHECKBOXS */}
                        <CardText>
                          TEST This involves assigning a value to the declared
                          variable. Initialization can occur at the time of
                          declaration or later in the code. Example:
                        </CardText>
                        <p>Content for Tab 2</p>
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="3">
                      <CardBody>
                        <p>Content for Tab 3</p>
                      </CardBody>
                    </TabPane>
                  </TabContent>
                </Card>
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => toggle("1")}
                    >
                      Tab 1
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => toggle("2")}
                    >
                      Tab 2
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => toggle("3")}
                    >
                      Tab 3
                    </NavLink>
                  </NavItem>
                </Nav>
              </CodeExecutor>
            </Col>
          </Row>
        </section>
      </main>
    </>
  );
};

export default VariableDeclarationAndInitialization;
